import {
  PLAYER_SPEED,
  ATTACK_RADIUS, MAX_ATTACK_RADIUS,
  ATTACK_COOLDOWN, MIN_ATTACK_COOLDOWN,
  ENEMY_SPEED,
} from '../../constants';
import { computeEffectiveStats } from '../../data/items';
import { applyTalents }          from '../../data/talentTree';

/**
 * Displays the player's stats, reflecting equipped-item, enhancement, and talent bonuses.
 * Pass the `equipped` map from useInventory and `activatedTalents` array to see live values.
 */
export function StatsList({ equipped = {}, activatedTalents = [] }) {
  const eff = computeEffectiveStats(equipped);
  applyTalents(eff, activatedTalents);

  const stats = [
    { label: 'Move Speed',        value: (PLAYER_SPEED * eff.speedMult).toFixed(1)                              },
    { label: 'Attack Damage',     value: Math.round(eff.attackDamage)                                            },
    { label: 'Attack Range',      value: `${Math.min(MAX_ATTACK_RADIUS, Math.round(ATTACK_RADIUS * eff.rangeMult))} px`                      },
    { label: 'Attack Cooldown',   value: `${(Math.max(MIN_ATTACK_COOLDOWN, ATTACK_COOLDOWN * Math.max(eff.cdMult, 0.1)) / 1000).toFixed(2)} s` },
    { label: 'Enemy Speed',       value: (ENEMY_SPEED * Math.max(eff.enemySlowMult, 0.1)).toFixed(2)            },
    { label: 'XP per Kill',       value: eff.xpPerKill                                                          },
    { label: 'Max HP',            value: eff.maxHp ?? 100                                                        },
    { label: 'Dodge Chance',      value: `${Math.round((eff.dodgeChance ?? 0) * 100)}%`                         },
    { label: 'Armor',             value: eff.armor ?? 0                                                         },
    { label: 'Fire Resistance',   value: `${Math.round((eff.fireRes ?? 0) * 100)}%`                             },
    { label: 'Lightning Resist',  value: `${Math.round((eff.lightningRes ?? 0) * 100)}%`                        },
    { label: 'Crit Chance',       value: `${Math.round((eff.critRate ?? 0.05) * 100)}%`                         },
    { label: 'Crit Damage',       value: `×${(eff.critDamage ?? 1.5).toFixed(2)}`                               },
  ];

  return (
    <div className="stats-panel">
      <h3 className="stats-panel-title">Base Stats</h3>
      <ul className="stats-list">
        {stats.map(({ label, value }) => (
          <li key={label} className="stat-row">
            <span className="stat-label">{label}</span>
            <span className="stat-value">{value}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
